(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moments-about-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const video = document.querySelector('[data-m-astory-video]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = !!(navigator.connection && navigator.connection.saveData);
    const pause = document.querySelector('[data-m-astory-pause]');
    if (video && video.dataset.src && !reduced && !saveData && window.matchMedia('(min-width: 750px)').matches && 'IntersectionObserver' in window) {
      let paused = false;
      new IntersectionObserver((entries, obs) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        obs.disconnect();
        video.src = video.dataset.src;
        video.play().then(() => { video.setAttribute('data-playing', ''); if (pause) pause.hidden = false; }).catch(() => {});
      }).observe(video);
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else if (video.src && !paused) video.play().catch(() => {}); });
      if (pause) pause.addEventListener('click', () => {
        paused = !paused;
        if (paused) video.pause(); else video.play().catch(() => {});
        pause.setAttribute('aria-label', paused ? pause.dataset.play : pause.dataset.pause);
      });
    }
    const dialog = document.querySelector('[data-m-astory-dialog]');
    const open = document.querySelector('[data-m-astory-open]');
    if (dialog && open) {
      const player = dialog.querySelector('video');
      open.addEventListener('click', () => { player.src = player.dataset.src; dialog.showModal(); player.play().catch(() => {}); });
      dialog.querySelector('[data-m-astory-close]').addEventListener('click', () => { player.pause(); dialog.close(); open.focus(); });
      dialog.addEventListener('cancel', () => player.pause());
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moments-brand-marquee"] && !Shopify.designMode) return;
  try {
    
  // Drag (mouse) or swipe (touch) the brand strip back and forth; it carries on by itself when let go (owner request
  // 2026-10-31: "if I miss the brand I can get back to it"). Drives the CSS animation's clock, so the loop stays seamless.
  // Vertical swipes still scroll the page (touch-action: pan-y). A drag of more than 6px does not open the brand under it.
  (() => {
    const init = (ticker) => {
      if (ticker.dataset.dragReady) return;
      const track = ticker.querySelector('.m-ticker__track');
      const animation = track && track.getAnimations()[0];
      if (!animation) return; // reduced motion: a static row, nothing to drag
      ticker.dataset.dragReady = 'true';

      const rtl = document.documentElement.dir === 'rtl';
      const duration = animation.effect.getComputedTiming().duration;
      let startX = 0;
      let startTime = 0;
      let dragging = false;
      let moved = false;
      let hovered = false;

      const resume = () => {
        if (!dragging && !hovered && !ticker.contains(document.activeElement)) animation.play();
      };

      ticker.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') {
          hovered = true;
          animation.pause();
        }
      });
      ticker.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') {
          hovered = false;
          resume();
        }
      });
      ticker.addEventListener('focusin', () => animation.pause());
      ticker.addEventListener('focusout', () => setTimeout(resume));

      ticker.addEventListener('pointerdown', (event) => {
        if (event.button !== 0) return;
        dragging = true;
        moved = false;
        startX = event.clientX;
        startTime = animation.currentTime;
        animation.pause();
      });
      ticker.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const dx = event.clientX - startX;
        if (!moved && Math.abs(dx) > 6) {
          moved = true;
          ticker.setPointerCapture(event.pointerId);
          ticker.classList.add('is-dragging');
        }
        if (!moved) return;
        const msPerPx = duration / (track.scrollWidth / 2);
        const time = startTime - dx * (rtl ? -1 : 1) * msPerPx;
        animation.currentTime = ((time % duration) + duration) % duration;
      });
      const end = () => {
        if (!dragging) return;
        dragging = false;
        ticker.classList.remove('is-dragging');
        resume();
      };
      ticker.addEventListener('pointerup', end);
      ticker.addEventListener('pointercancel', end);
      // a drag is not a click on the logo under the finger
      ticker.addEventListener(
        'click',
        (event) => {
          if (moved) {
            event.preventDefault();
            event.stopPropagation();
            moved = false;
          }
        },
        true
      );
      ticker.addEventListener('dragstart', (event) => event.preventDefault());
    };

    const run = () => document.querySelectorAll('.m-brands .m-ticker').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moments-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('moments-bundle-boot')) {
    customElements.define('moments-bundle-boot', class extends HTMLElement {});
    (() => {
      const root = document.querySelector('[data-m-bundle]');
      if (!root) return;
      const $ = (s) => root.querySelector(s);
      const slotsEl = $('[data-m-slots]');
      const gridEl = $('[data-m-grid]');
      const labels = $('[data-m-add-label]').dataset;
      const KEY = 'moments-bundle-v1';
      const min = Number(root.dataset.min) || 3;
      const max = Number(root.dataset.max) || 12;
      const threshold = Number(root.dataset.threshold) || 0;
      const tiersOn = root.dataset.tiers === 'true';
      const perks = {};
      (root.dataset.perks || '').split('~').forEach((x) => { const [n, l] = x.split('|'); if (n && l) perks[Number(n)] = l; });
      const confirmed = root.dataset.tiersConfirmed === 'true';
      const tierPercent = Number(root.dataset.tierPercent) || 0;
      const T = (k, map) => Object.entries(map || {}).reduce((s, [a, b]) => s.split(a).join(b), root.dataset[k] || '');
      const money = (cents) => {
        const fmt = root.dataset.money || 'LE #';
        const n = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return fmt.replace(/\{\{\s*amount\s*\}\}/, n).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString('en-US')).replace('#', n);
      };
      let items = [];
      let id = '';
      try { const s = JSON.parse(localStorage.getItem(KEY) || 'null'); if (s && Array.isArray(s.items)) { items = s.items; id = s.id || ''; } } catch (e) { /* storage unavailable: this visit only */ }
      if (!id) id = Math.random().toString(36).slice(2, 8).toUpperCase();
      const save = () => { try { localStorage.setItem(KEY, JSON.stringify({ id, items })); } catch (e) { /* ignore */ } };
      const say = (msg) => { $('[data-m-status]').textContent = ''; setTimeout(() => { $('[data-m-status]').textContent = msg; }, 30); };
      const showError = (msg) => { const el = $('[data-m-error]'); el.textContent = msg || ''; el.hidden = !msg; };

      const render = () => {
        const count = items.length;
        const subtotal = items.reduce((s, i) => s + i.price, 0);
        // slots
        const total = Math.max(8, count + 1);
        slotsEl.textContent = '';
        for (let n = 1; n <= total; n++) {
          const it = items[n - 1];
          const li = document.createElement('li');
          li.className = 'm-slot' + (it ? ' m-slot--filled' : '');
          const num = document.createElement('span'); num.className = 'm-slot__num'; num.textContent = n; li.appendChild(num);
          if (it) {
            const img = document.createElement('img'); img.src = it.image; img.alt = it.title; img.loading = 'lazy'; li.appendChild(img);
            const rm = document.createElement('button'); rm.type = 'button'; rm.className = 'm-slot__remove'; rm.textContent = '×';
            rm.setAttribute('aria-label', T('tRemove', { __T__: it.title }));
            rm.addEventListener('click', () => { items.splice(n - 1, 1); save(); render(); say(T('tRemoved', { __T__: it.title })); });
            li.appendChild(rm);
          } else {
            const plus = document.createElement('span'); plus.className = 'm-slot__plus'; plus.textContent = '+'; plus.setAttribute('aria-hidden', 'true'); li.appendChild(plus);
            li.setAttribute('aria-label', T('tEmptySlot', { __N__: n }));
          }
          const perk = perks[n];
          if (perk) { const b = document.createElement('span'); b.className = 'm-slot__perk'; b.textContent = perk; li.appendChild(b); }
          slotsEl.appendChild(li);
        }
        // summary
        $('[data-m-count]').textContent = T('tItems', { __C__: count });
        $('[data-m-subtotal]').textContent = money(subtotal);
        const need = Math.max(0, min - count);
        let hint = '';
        if (need > 0) hint = T('tAddMore', { __C__: need });
        else if (threshold && subtotal < threshold) hint = T('tShippingHint', { __A__: money(threshold - subtotal) });
        $('[data-m-hint]').textContent = hint;
        const saving = $('[data-m-saving]');
        if (tiersOn && confirmed && tierPercent > 0 && count >= min) { saving.hidden = false; saving.textContent = T('tSaving', { __A__: money(Math.round(subtotal * tierPercent / 100)) }); } else { saving.hidden = true; }
        const ok = count >= min;
        $('[data-m-checkout]').disabled = !ok;
        const bar = $('[data-m-bar]');
        bar.hidden = count === 0;
        $('[data-m-bar-text]').textContent = T('tItems', { __C__: count }) + ' · ' + money(subtotal);
        $('[data-m-bar-checkout]').disabled = !ok;
      };

      // ---- slots scrolling (arrows and keyboard)
      const sign = () => (getComputedStyle(root).direction === 'rtl' ? -1 : 1);
      $('[data-m-next]').addEventListener('click', () => slotsEl.scrollBy({ left: sign() * 280, behavior: 'smooth' }));
      $('[data-m-prev]').addEventListener('click', () => slotsEl.scrollBy({ left: -sign() * 280, behavior: 'smooth' }));
      slotsEl.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); slotsEl.scrollBy({ left: 140, behavior: 'smooth' }); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); slotsEl.scrollBy({ left: -140, behavior: 'smooth' }); }
      });

      // ---- grid: real product cards from the collection and search pages
      let source = '/collections/all';
      let page = 1;
      let sectionId = '';
      let query = '';
      let loading = false;
      let more = false;
      const buildUrl = (p) => {
        const base = query ? '/search?q=' + encodeURIComponent(query) + '&type=product' : source;
        const sep = base.includes('?') ? '&' : '?';
        return base + sep + 'page=' + p + (sectionId ? '&section_id=' + encodeURIComponent(sectionId) : '');
      };
      const decorate = (li) => {
        const link = li.querySelector('a[href*="/products/"]');
        if (!link) return null;
        const handle = (link.getAttribute('href').split('/products/')[1] || '').split('?')[0];
        const sold = /sold out/i.test(li.textContent);
        const btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'm-add'; btn.dataset.handle = handle;
        btn.textContent = sold ? labels.sold : labels.add; btn.disabled = sold;
        li.appendChild(btn);
        return li;
      };
      const load = async (reset) => {
        if (loading) return; loading = true;
        const moreBtn = $('[data-m-more]'); moreBtn.disabled = true;
        if (reset) { page = 1; gridEl.textContent = ''; $('[data-m-none]').hidden = true; }
        try {
          const res = await fetch(buildUrl(page));
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          if (!sectionId) { const sec = doc.querySelector('[id^="shopify-section-template--"][id$="__main"], [id^="shopify-section-template--"][id*="main"]'); if (sec) sectionId = sec.id.replace('shopify-section-', ''); }
          const cards = [...doc.querySelectorAll('product-card')].map((c) => c.closest('li') || c);
          cards.forEach((li) => { const node = document.importNode(li, true); const el = node.tagName === 'LI' ? node : (() => { const w = document.createElement('li'); w.appendChild(node); return w; })(); if (decorate(el)) gridEl.appendChild(el); });
          more = cards.length >= 12 && !!doc.querySelector('a[href*="page=' + (page + 1) + '"]');
          if (!gridEl.children.length) $('[data-m-none]').hidden = false;
        } catch (e) { showError(labels.error); }
        loading = false; moreBtn.disabled = false; moreBtn.hidden = !more;
      };
      $('[data-m-more]').addEventListener('click', () => { page += 1; load(false); });

      const chips = [...root.querySelectorAll('[data-m-chip]')];
      chips.forEach((chip) => chip.addEventListener('click', () => {
        chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
        source = chip.dataset.mChip; query = ''; $('[data-m-search]').value = ''; sectionId = ''; load(true);
      }));
      let timer;
      $('[data-m-search]').addEventListener('input', (e) => {
        clearTimeout(timer);
        timer = setTimeout(() => { query = e.target.value.trim(); sectionId = ''; if (query) chips.forEach((c) => c.setAttribute('aria-pressed', 'false')); else chips[0].setAttribute('aria-pressed', 'true'); load(true); }, 350);
      });

      // ---- add and checkout
      gridEl.addEventListener('click', async (e) => {
        const btn = e.target.closest('.m-add');
        if (!btn || btn.disabled) return;
        showError('');
        if (items.length >= max) { showError(T('tLimit')); return; }
        btn.disabled = true;
        try {
          const res = await fetch('/products/' + btn.dataset.handle + '.js');
          if (!res.ok) throw new Error('product');
          const p = await res.json();
          const v = p.variants.find((x) => x.available);
          if (!v) { btn.textContent = labels.sold; return; }
          let img = (v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
          if (img) img += (img.includes('?') ? '&' : '?') + 'width=240';
          items.push({ handle: p.handle, title: p.title, vendor: p.vendor, variantId: v.id, price: v.price, image: img });
          save(); render(); say(T('tAdded', { __T__: p.title }));
          btn.disabled = false;
        } catch (err) { showError(labels.error); btn.disabled = false; }
      });
      const checkout = async (btn) => {
        if (items.length < min) return;
        showError(''); btn.disabled = true;
        const lines = {};
        items.forEach((i) => { lines[i.variantId] = (lines[i.variantId] || 0) + 1; });
        const payload = { items: Object.entries(lines).map(([vid, q]) => ({ id: Number(vid), quantity: q, properties: { Bundle: 'MOMENTS bundle ' + id } })) };
        try {
          const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
          if (res.status === 422) { showError(labels.unavailable); btn.disabled = false; return; }
          if (!res.ok) throw new Error('cart');
          items = []; save();
          window.location.href = '/cart';
        } catch (err) { showError(labels.error); btn.disabled = false; }
      };
      $('[data-m-checkout]').addEventListener('click', (e) => checkout(e.currentTarget));
      $('[data-m-bar-checkout]').addEventListener('click', (e) => checkout(e.currentTarget));

      // mini bar only while the summary is off screen (phones)
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => { root.dataset.summaryVisible = entries.some((en) => en.isIntersecting) ? 'true' : 'false'; const bar = $('[data-m-bar]'); bar.style.display = root.dataset.summaryVisible === 'true' ? 'none' : ''; }).observe($('[data-m-summary]'));
      }

      render();
      load(true);
    })();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moments-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-m-faq]');
    if (!root) return;
    const input = root.querySelector('[data-m-faq-search]');
    const items = [...root.querySelectorAll('[data-m-faq-item]')];
    const groups = [...root.querySelectorAll('[data-m-faq-group]')];
    const empty = root.querySelector('[data-m-faq-empty]');
    input.addEventListener('input', () => {
      const q = input.value.trim().toLowerCase();
      let shown = 0;
      items.forEach((item) => {
        const hit = !q || item.textContent.toLowerCase().includes(q);
        item.hidden = !hit;
        if (hit) shown++;
        if (q && hit) item.open = true;
      });
      groups.forEach((g) => { g.hidden = ![...g.querySelectorAll('[data-m-faq-item]')].some((i) => !i.hidden); });
      empty.hidden = shown > 0;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moments-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const hero = document.querySelector('[data-m-hero]');
    if (!hero) return;

    const root = document.documentElement;
    const slides = [...hero.querySelectorAll('.m-slide')];
    const switches = [...hero.querySelectorAll('[data-moment-switch]')];
    const playback = hero.querySelector('[data-m-playback]');
    const pauseBtn = hero.querySelector('[data-m-pause]');
    const muteBtn = hero.querySelector('[data-m-mute]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = !!(navigator.connection && navigator.connection.saveData);
    const desktop = window.matchMedia('(min-width: 750px)');
    const state = { paused: false, muted: true, visible: true, tabVisible: !document.hidden };

    const activeSlide = () => slides.find((s) => s.dataset.moment === root.dataset.moment) || slides[0];
    const videoOf = (slide) => slide && slide.querySelector('.m-slide__video');

    const loadVideo = (video) => {
      if (!video || video.dataset.loaded || reduced || saveData) return false;
      const src = desktop.matches ? video.dataset.desktopSrc : video.dataset.mobileSrc;
      if (!src) return false;
      video.dataset.loaded = 'true';
      video.preload = 'metadata';
      video.src = src;
      return true;
    };

    const syncPlayback = () => {
      slides.forEach((slide) => {
        const video = videoOf(slide);
        if (!video || !video.dataset.loaded) return;
        const shouldPlay = slide === activeSlide() && !state.paused && state.visible && state.tabVisible;
        if (shouldPlay) {
          video.play().then(() => video.setAttribute('data-playing', '')).catch(() => {});
        } else {
          video.pause();
        }
      });
      hero.toggleAttribute('data-paused', state.paused || !state.visible || !state.tabVisible);
    };

    const activate = (moment, user) => {
      root.dataset.moment = moment;
      if (user) { try { sessionStorage.setItem('mMoment', moment); } catch (e) {} }
      slides.forEach((slide) => {
        const on = slide.dataset.moment === moment;
        slide.toggleAttribute('inert', !on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) {
          const poster = slide.querySelector('.m-slide__poster');
          if (poster && poster.loading === 'lazy') { poster.loading = 'eager'; poster.fetchPriority = 'high'; }
          const blur = slide.querySelector('.m-slide__blur');
          if (blur) blur.loading = 'eager';
          const packshot = slide.querySelector('.m-slide__packshot');
          if (packshot) packshot.loading = 'eager';
        }
      });
      switches.forEach((btn) => btn.setAttribute('aria-pressed', String(btn.dataset.momentSwitch === moment)));
      const slide = activeSlide();
      const video = videoOf(slide);
      if (video && !video.dataset.loaded) {
        // Desktop video starts only after the poster has painted.
        const start = () => { if (loadVideo(video)) syncPlayback(); };
        const poster = slide.querySelector('.m-slide__poster');
        if (poster && !poster.complete) poster.addEventListener('load', () => requestAnimationFrame(start), { once: true });
        else requestAnimationFrame(() => setTimeout(start, 200));
      }
      if (playback) playback.hidden = !(video && video.dataset.desktopSrc && !reduced && !saveData);
      syncPlayback();
    };

    switches.forEach((btn) => btn.addEventListener('click', () => activate(btn.dataset.momentSwitch, true)));

    if (pauseBtn) {
      pauseBtn.addEventListener('click', () => {
        state.paused = !state.paused;
        pauseBtn.setAttribute('aria-pressed', String(state.paused));
        pauseBtn.setAttribute('aria-label', state.paused ? pauseBtn.dataset.labelPlay : pauseBtn.dataset.labelPause);
        pauseBtn.querySelector('[data-icon-pause]').toggleAttribute('hidden', state.paused);
        pauseBtn.querySelector('[data-icon-play]').toggleAttribute('hidden', !state.paused);
        syncPlayback();
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', () => {
        state.muted = !state.muted;
        slides.forEach((slide) => { const v = videoOf(slide); if (v) v.muted = state.muted; });
        muteBtn.setAttribute('aria-pressed', String(state.muted));
        muteBtn.setAttribute('aria-label', state.muted ? muteBtn.dataset.labelUnmute : muteBtn.dataset.labelMute);
        muteBtn.querySelector('[data-icon-on]').toggleAttribute('hidden', state.muted);
        muteBtn.querySelector('[data-icon-off]').toggleAttribute('hidden', !state.muted);
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        state.visible = entries.some((entry) => entry.isIntersecting);
        syncPlayback();
      }, { threshold: 0.15 }).observe(hero);
    }

    document.addEventListener('visibilitychange', () => { state.tabVisible = !document.hidden; syncPlayback(); });
    desktop.addEventListener('change', () => activate(root.dataset.moment, false));

    activate(root.dataset.moment || (slides[0] && slides[0].dataset.moment), false);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moments-refer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-m-refer]');
    if (!root) return;
    const url = root.dataset.url;
    const text = root.dataset.text;
    const status = root.querySelector('[data-m-refer-status]');
    const copy = root.querySelector('[data-m-refer-copy]');
    const share = root.querySelector('[data-m-refer-share]');
    copy.addEventListener('click', async () => {
      try { await navigator.clipboard.writeText(url); } catch (e) {
        const t = document.createElement('textarea'); t.value = url; document.body.appendChild(t); t.select(); document.execCommand('copy'); t.remove();
      }
      status.textContent = copy.dataset.copied;
      const label = copy.textContent; copy.textContent = copy.dataset.copied;
      setTimeout(() => { copy.textContent = label; }, 1800);
    });
    if (navigator.share) {
      share.hidden = false;
      share.addEventListener('click', () => navigator.share({ title: document.title, text, url }).catch(() => {}));
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
